export enum STATUS {
  FAILED = 'failed',
  SUCCEEDED = 'succeeded',
  NOTENDED = 'notended'
};

export const EXTRA_COLOR = '#F37143';

export const INITIAL_SPLIT_INDEX = 0;
